const mode = process.env.REACT_APP_MODE || "LIVE";


const API = {
  BASE_URL: "",
  PAYMENT_BASE_URL: "",
  TASK_BASE_URL: "",

  SUBMIT: "surgeStudents/createStudent",
  UPDATE_PAYMENT: "surgeStudents/paymentUpdate",
  GET_PAID_STUDENTS: "surgeStudents/paidStudents",

  SPEAKER_SUBMIT: "surgeStudents/createMentor",
  SPEAKER_UPDATE_PAYMENT: "surgeStudents/mentorPaymentUpdate",
  GET_PAID_SPEAKER: "surgeStudents/paidMentors",

  COLLEGE_SUBMIT: "surgeStudents/createInstitution",
  COLLEGE_UPDATE_PAYMENT: "surgeStudents/institutionPaymentUpdate",
  COLLEGE_GET_PAID_COLLEGES: "surgeStudents/paidInstitutions",

  CREATE_TASK: "createTask",


  KEY: "rzp_live_RcMhSK2LLIsV1q",
  PAYMENT: "payment",
  PAYMENT_SUCCESS: "ticketSuccess",
  PAYMENT_CLOSED: "paymentClosed"
};


// Base URL
if (mode === "LOCAL") {
  API["BASE_URL"] = "https://oneappbackend.hifrnds.in/api/v3/";
}
if (mode === "DEV") {
  API["BASE_URL"] = "https://oneappbackend.hifrnds.in/api/v3/";
}
if (mode === "LIVE") {
  API["BASE_URL"] = "https://k8sm.onlyapp.in/node/api/v3/";
}

// Base URL
if (mode === "LOCAL") {
  API["TASK_BASE_URL"] = "https://oneappdev.hifrds.com/api/v5/task/";
}
if (mode === "DEV") {
  API["TASK_BASE_URL"] = "https://oneappdev.hifrds.com/api/v5/task/";
}
if (mode === "LIVE") {
  API["TASK_BASE_URL"] = "https://k8sm.onlyapp.in/task/api/v5/task/";
}

// Payment Base URL
if (mode === "LOCAL") {
  API["PAYMENT_BASE_URL"] = "https://pricedev.hifrds.com/api/v1/workfast/";
}
if (mode === "DEV") {
  API["PAYMENT_BASE_URL"] = "https://pricedev.hifrds.com/api/v1/workfast/";
}
if (mode === "LIVE") {
  API["PAYMENT_BASE_URL"] = "https://pricelive.hifrds.com/api/v1/workfast/";
}

export default API;
